/* AITO — theme behaviours for Shopify.
   header · mobile nav · accordions · product variant form · AJAX cart drawer
   Load before </body>:  {{ 'aito.js' | asset_url | script_tag }}  */
(function () {
  "use strict";

  /* ---------------- a11y utilities ---------------- */
  function escHtml(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var liveRegion;
  function announce(msg, assertive) {
    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.className = "visually-hidden";
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("role", "status");
      document.body.appendChild(liveRegion);
    }
    liveRegion.setAttribute("aria-live", assertive ? "assertive" : "polite");
    liveRegion.textContent = "";
    window.setTimeout(function () { liveRegion.textContent = msg; }, 50);
  }
  function focusables(container) {
    return container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
  }
  function trapFocus(container, e) {
    if (e.key !== "Tab") return;
    var f = focusables(container);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function setInert(el, on) {
    if (!el) return;
    try { el.inert = on; } catch (err) { /* older engines: aria-hidden still applies */ }
    el.setAttribute("aria-hidden", on ? "true" : "false");
  }

  /* ---------------- copy ----------------
     Everything this file renders is written by the merchant's locale, not by
     this file. The layout hands it in; these are only the fallbacks that keep
     the script working if it is ever loaded without them. */
  var S = window.AITO_STRINGS || {};
  function t(key, fallback, vars) {
    var out = S[key] != null ? S[key] : fallback;
    if (vars) for (var k in vars) out = out.split(k).join(vars[k]);
    return out;
  }
  function itemCount(n) {
    return n === 1 ? t("itemOne", "1 item") : t("itemOther", n + " items", { "__n__": n });
  }

  /* ---------------- money ----------------
     The store's money format is markup, not text: Admin holds
     <span class=money>{{amount}} NIS</span> because the BUCKS currency-converter
     embed finds prices by that span. formatMoney() reproduces the format the way
     Liquid's money filter does, so its result is HTML and lands in the page
     through innerHTML. Anything read aloud or set as text takes moneyText(),
     which is the same price with the tags dropped. tools/money-format-check.py
     holds the line. */
  var MONEY = window.AITO_MONEY || "${{amount}}";
  function commas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
  function formatMoney(cents) {
    var v = (cents || 0) / 100;
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, t) {
      if (t === "amount") return commas(v.toFixed(2));
      if (t === "amount_no_decimals") return commas(Math.round(v).toString());
      if (t === "amount_with_comma_separator") { var p = v.toFixed(2).split("."); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + p[1]; }
      if (t === "amount_no_decimals_with_comma_separator") return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return v.toFixed(2);
    });
  }
  function moneyText(cents) {
    var d = document.createElement("div");
    d.innerHTML = formatMoney(cents);
    return (d.textContent || "").trim();
  }

  /* ---------------- header ---------------- */
  function initHeader() {
    var header = document.querySelector(".site-header");
    var line = document.querySelector(".scroll-line");
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle("is-stuck", y > 24);
      if (line) {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        line.style.width = (h > 0 ? (y / h) * 100 : 0) + "%";
      }
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------------- mobile nav ---------------- */
  function initMobileNav() {
    var header = document.querySelector(".site-header");
    if (!header || document.getElementById("mobileMenu")) return;
    var utils = header.querySelector(".utils");
    var tog = document.createElement("button");
    tog.className = "nav-toggle";
    tog.setAttribute("aria-label", t("openMenu", "open menu"));
    tog.setAttribute("aria-expanded", "false");
    tog.setAttribute("aria-controls", "mobileMenu");
    tog.innerHTML = "<span></span><span></span><span></span>";
    (utils || header).appendChild(tog);

    var menu = document.createElement("div");
    menu.className = "mobile-menu";
    menu.id = "mobileMenu";
    menu.setAttribute("role", "dialog");
    menu.setAttribute("aria-modal", "true");
    menu.setAttribute("aria-label", "Menu");
    menu.setAttribute("tabindex", "-1");
    /* p13 · The panel was authored for four big links. Injecting nine category
       sub-links into it inverted the hierarchy — one huge word above nine tiny
       grey ones — and cloning textContent glued each label to its count, so a
       row read "shirts 8". The categories are the reason the menu exists, so
       they are now a proper index: label left, count right, rules between. */
    var groups = "";
    header.querySelectorAll(".main-nav > *").forEach(function (node) {
      var isGroup = node.classList && node.classList.contains("has-sub");
      var head = isGroup ? node.querySelector("a[aria-haspopup]") : node;
      if (!head || head.tagName !== "A") return;
      var headHtml = '<a class="mm-head" href="' + head.getAttribute("href") + '">' +
                     escHtml(head.textContent.trim()) + "</a>";
      if (!isGroup) { groups += headHtml; return; }
      var rows = "";
      node.querySelectorAll(".nav-sub-a").forEach(function (s) {
        var label = s.querySelector("span:not(.nav-sub-n)");
        var count = s.querySelector(".nav-sub-n");
        rows += '<a href="' + s.getAttribute("href") + '">' +
                '<span class="mm-t">' + escHtml(label ? label.textContent.trim() : s.textContent.trim()) + "</span>" +
                (count ? '<span class="mm-n">' + escHtml(count.textContent.trim()) + "</span>" : "") +
                "</a>";
      });
      groups += '<div class="mm-group">' + headHtml + '<div class="mm-list">' + rows + "</div></div>";
    });
    var links = groups;
    var utilLinks = "";
    header.querySelectorAll(".utils a").forEach(function (a) {
      /* preserve behaviour attributes so search/cart toggles keep working inside the menu */
      var attrs = "";
      if (a.hasAttribute("data-search-toggle")) attrs += " data-search-toggle";
      if (a.hasAttribute("data-cart-toggle")) attrs += " data-cart-toggle";
      utilLinks += '<a href="' + a.getAttribute("href") + '"' + attrs + ">" + escHtml(a.textContent.trim()) + "</a>";
    });
    if (!utilLinks) utilLinks = '<a href="/search" data-search-toggle>' + escHtml(t("search", "search")) + '</a><a href="/cart">' + escHtml(t("bag", "bag")) + '</a>';
    var social = "";
    if (header.dataset.ig) social += '<a href="' + header.dataset.ig + '" target="_blank" rel="noopener">instagram</a>';
    if (header.dataset.tt) social += '<a href="' + header.dataset.tt + '" target="_blank" rel="noopener">tiktok</a>';
    menu.innerHTML =
      '<div class="mm-idx">' + escHtml(t("menuLabel", "menu")) + '</div><nav class="mm-links">' + links + "</nav>" +
      '<div class="mm-foot"><div class="mm-utils">' + utilLinks + "</div>" +
      (social ? '<div class="mm-social">' + social + "</div>" : "") + "</div>";
    document.body.appendChild(menu);

    setInert(menu, true);
    /* QA-002: .mobile-menu carries `visibility:hidden` plus `transition:visibility .5s`, so at the
       instant .open is added the computed visibility is still `hidden` and .focus() is a silent
       no-op. It only flips to `visible` once the transition has advanced past t=0 — i.e. on the
       SECOND rendered frame. Focus the panel itself (not its first link) so the dialog is announced
       before the menu items, and keep a timeout fallback for engines that coalesce frames or
       disable the transition under prefers-reduced-motion. */
    function focusPanel() {
      var tries = 0;
      function attempt() {
        if (!menu.classList.contains("open")) return;
        if (menu.contains(document.activeElement) || document.activeElement === menu) return;
        menu.focus();
        if (++tries < 3 && document.activeElement !== menu) window.setTimeout(attempt, 120);
      }
      window.requestAnimationFrame(function () { window.requestAnimationFrame(attempt); });
      window.setTimeout(attempt, 120);
    }
    function close() {
      if (!menu.classList.contains("open")) return;
      document.body.classList.remove("menu-open"); menu.classList.remove("open");
      tog.setAttribute("aria-expanded", "false"); tog.setAttribute("aria-label", t("openMenu", "open menu"));
      setInert(menu, true); tog.focus();
    }
    function open() {
      document.body.classList.add("menu-open"); menu.classList.add("open");
      tog.setAttribute("aria-expanded", "true"); tog.setAttribute("aria-label", t("closeMenu", "close menu"));
      setInert(menu, false);
      focusPanel();
    }
    tog.addEventListener("click", function () { menu.classList.contains("open") ? close() : open(); });
    menu.addEventListener("keydown", function (e) { trapFocus(menu, e); });
    menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { setInert(menu, true); document.body.classList.remove("menu-open"); menu.classList.remove("open"); tog.setAttribute("aria-expanded", "false"); tog.setAttribute("aria-label", t("openMenu", "open menu")); }); });
    window.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    window.addEventListener("resize", function () { if (window.innerWidth > 820 && menu.classList.contains("open")) close(); });
  }

  /* ---------------- accordions ---------------- */
  /* ---------------- header dropdown (F—06) ----------------
     CSS handles hover and :focus-within for the open state; this only keeps
     aria-expanded truthful and gives keyboard users an Escape route. */
  function initNavDropdown() {
    document.querySelectorAll(".main-nav .has-sub").forEach(function (item) {
      var trigger = item.querySelector("a[aria-haspopup]");
      if (!trigger) return;
      function set(state) { trigger.setAttribute("aria-expanded", state ? "true" : "false"); }
      item.addEventListener("mouseenter", function () { set(true); });
      item.addEventListener("mouseleave", function () { set(false); });
      item.addEventListener("focusin", function () { set(true); });
      item.addEventListener("focusout", function () {
        window.setTimeout(function () { if (!item.contains(document.activeElement)) set(false); }, 0);
      });
      item.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { set(false); trigger.focus(); }
      });
    });
  }

  function initAccordions(scope) {
    (scope || document).querySelectorAll(".acc .acc-h").forEach(function (h) {
      h.addEventListener("click", function () {
        var open = h.closest(".acc").classList.toggle("open");
        h.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }

  /* ---------------- product variant form ---------------- */
  function initProductForm(scope) {
    var root = scope || document;
    var form = root.querySelector(".product-form");
    var json = document.getElementById("ProductJSON");
    if (!form || !json) return;
    var product = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector("[data-price]");
    var btn = form.querySelector('button[type="submit"]');
    var selected = {};

    function findVariant() {
      return product.variants.filter(function (v) {
        return product.options.every(function (o, i) { return selected[i] === v.options[i]; });
      })[0];
    }
    /* Sold-out values used to render identically to available ones — on thin
       stock most of the row was a trap. Marks each value that has no available
       variant given the other selected options; buttons stay clickable so the
       sold-out announcement still fires. */
    function markAvailability() {
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        group.querySelectorAll("[data-val]").forEach(function (b) {
          var val = b.getAttribute("data-val");
          var ok = product.variants.some(function (v) {
            if (!v.available || v.options[idx] !== val) return false;
            return product.options.every(function (o, j) { return j === idx || selected[j] == null || v.options[j] === selected[j]; });
          });
          b.classList.toggle("is-oos", !ok);
          b.setAttribute("aria-disabled", ok ? "false" : "true");
        });
      });
    }
    function update(announceChange) {
      markAvailability();
      var v = findVariant();
      if (v) {
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = formatMoney(v.price);
          // The price block listens for this to hand the fresh .money node to BUCKS.
          priceEl.dispatchEvent(new CustomEvent("aito:price", { bubbles: true }));
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? (btn.getAttribute("data-label") || t("addToCart", "add to bag")) : t("soldOut", "sold out");
        }
        if (announceChange) announce(v.title + " — " + moneyText(v.price) + (v.available ? "" : " — " + t("soldOut", "sold out")));
      } else if (btn) {
        btn.disabled = true; btn.textContent = t("unavailable", "unavailable");
        if (announceChange) announce(t("unavailable", "this combination is unavailable"));
      }
    }
    /* The row is a radiogroup, not a pile of buttons. The .sel class alone was
       invisible to assistive tech, so aria-checked now carries the selection and a
       roving tabindex collapses the row to one tab stop with arrows moving inside it —
       the ARIA radio contract. Class and attribute are set in the same place so they
       cannot drift apart. */
    function selectValue(group, b, idx, cur) {
      group.querySelectorAll("[data-val]").forEach(function (x) {
        var on = x === b;
        x.classList.toggle("sel", on);
        x.setAttribute("aria-checked", on ? "true" : "false");
        x.setAttribute("tabindex", on ? "0" : "-1");
      });
      selected[idx] = b.getAttribute("data-val");
      if (cur) cur.textContent = b.getAttribute("data-val");
    }
    form.querySelectorAll("[data-option-index]").forEach(function (group) {
      var idx = parseInt(group.getAttribute("data-option-index"), 10);
      var cur = group.parentElement.querySelector(".cur");
      var vals = Array.prototype.slice.call(group.querySelectorAll("[data-val]"));
      vals.forEach(function (b) {
        b.addEventListener("click", function () { selectValue(group, b, idx, cur); update(true); });
      });
      group.addEventListener("keydown", function (e) {
        var step = 0;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") step = 1;
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") step = -1;
        if (!step) return;
        var at = vals.indexOf(document.activeElement);
        if (at < 0) return;
        e.preventDefault();
        var next = vals[(at + step + vals.length) % vals.length];
        next.focus();
        selectValue(group, next, idx, cur);
        update(true);
      });
      var pre = group.querySelector('[data-val].sel') || vals[0];
      if (pre) selectValue(group, pre, idx, cur);
    });
    update();
  }

  /* ---------------- PDP: sticky buy bar + honest sticky column ----------------
     On phones the buy form sits below the whole gallery (~2 screens of images);
     the bar keeps price + add-to-bag reachable once the form scrolls away.
     On desktop the sticky info column is disabled whenever it is taller than
     the viewport — a sticky block that cannot fit just freezes below the fold. */
  function initStickyAtc() {
    var form = document.querySelector(".product-form");
    var info = document.querySelector(".product-info");
    if (!info) return;
    /* Sticky that never strands the layout: a column shorter than the viewport
       pins classically at top:108px; a taller one gets a negative sticky top so
       you scroll through all of it and then its BOTTOM pins to the viewport —
       the gallery never runs beside an empty right column, and the buy area
       stays on screen the whole way down. */
    function fit() {
      info.classList.remove("no-stick");
      if (window.matchMedia("(max-width:860px)").matches) { info.style.top = ""; return; }
      var overflow = info.offsetHeight - (window.innerHeight - 140);
      info.style.top = overflow > 0 ? (window.innerHeight - info.offsetHeight - 28) + "px" : "";
    }
    fit();
    window.addEventListener("resize", fit);
    document.addEventListener("click", function (e) {
      if (e.target.closest(".acc-h")) { window.setTimeout(fit, 60); window.setTimeout(fit, 450); }
    });
    if (!form) return;

    var bar = document.createElement("div");
    bar.className = "pdp-bar";
    bar.innerHTML = '<div class="pb-meta"><button type="button" class="pb-size">size</button><span class="pb-price"></span></div><button type="button" class="btn pb-add">add to bag</button>';
    document.body.appendChild(bar);
    var sizeBtn = bar.querySelector(".pb-size"), priceEl = bar.querySelector(".pb-price"), addBtn = bar.querySelector(".pb-add");
    var formBtn = form.querySelector('button[type="submit"]');
    function sync() {
      var cur = document.querySelector(".product-info .option .cur");
      var price = document.querySelector("[data-price]");
      if (cur && cur.textContent.trim()) { sizeBtn.textContent = t("sizePrefix", "size — __v__", { "__v__": cur.textContent.trim() }); sizeBtn.style.display = ""; }
      else sizeBtn.style.display = "none";
      priceEl.textContent = price ? price.textContent.trim() : "";
      if (formBtn) { addBtn.textContent = formBtn.textContent.trim() || "add to bag"; addBtn.disabled = formBtn.disabled; }
    }
    sync();
    form.addEventListener("click", function () { window.setTimeout(sync, 40); });
    document.addEventListener("submit", function (e) { if (e.target === form) { window.setTimeout(sync, 80); window.setTimeout(sync, 900); } }, true);
    sizeBtn.addEventListener("click", function () { form.scrollIntoView({ behavior: "smooth", block: "center" }); });
    addBtn.addEventListener("click", function () {
      if (addBtn.disabled) return;
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    });
    /* Visible whenever the in-page form isn't — on phones the form starts a
       gallery below the fold, so the bar works in both scroll directions.
       Plain scroll tracking (one getBoundingClientRect per frame-ish) instead
       of IntersectionObserver: throttled/background tabs can starve IO
       callbacks and leave the bar permanently stuck in one state. */
    var trackQueued = false;
    function track() {
      trackQueued = false;
      var r = form.getBoundingClientRect();
      bar.classList.toggle("show", r.bottom < 70 || r.top > window.innerHeight);
    }
    function queueTrack() {
      if (trackQueued) return;
      trackQueued = true;
      /* setTimeout, not rAF: rAF is starved in throttled/background tabs —
         the same failure mode that ruled out IntersectionObserver. */
      window.setTimeout(track, 60);
    }
    track();
    window.addEventListener("scroll", queueTrack, { passive: true });
    window.addEventListener("resize", queueTrack);
  }

  /* ---------------- AJAX cart drawer ---------------- */
  function initCart() {
    var drawer = document.getElementById("CartDrawer");
    var backdrop = document.getElementById("CartBackdrop");
    var lastTrigger = null;
    if (drawer) { setInert(drawer, true); drawer.addEventListener("keydown", function (e) { trapFocus(drawer, e); }); }
    function open() {
      if (!drawer) return;
      document.body.classList.add("cart-open"); drawer.classList.add("open"); if (backdrop) backdrop.classList.add("open");
      setInert(drawer, false);
      var f = focusables(drawer); if (f.length) f[0].focus();
    }
    function close() {
      if (!drawer || !drawer.classList.contains("open")) return;
      document.body.classList.remove("cart-open"); drawer.classList.remove("open"); if (backdrop) backdrop.classList.remove("open");
      setInert(drawer, true);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }

    function cartThumb(src) {
      if (!src) return "";
      return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=160";
    }
    function render(cart) {
      // The header link and the drawer's own heading are both rendered with the
      // page's count; after an AJAX add they must move together.
      document.querySelectorAll(".bag-count, .cd-title").forEach(function (b) { b.textContent = t("bagCount", "bag __n__", { "__n__": cart.item_count }); });
      if (!drawer) return;
      var items = drawer.querySelector(".cd-items");
      var subEl = drawer.querySelector("[data-subtotal]");
      var foot = drawer.querySelector(".cd-foot");
      if (subEl) subEl.innerHTML = formatMoney(cart.items_subtotal_price);
      if (foot) foot.style.display = cart.item_count ? "" : "none";
      if (!items) return;
      if (!cart.item_count) {
        items.innerHTML = '<div class="cd-empty">' + escHtml(t("emptyBag", "your bag is empty")) +
          '<br><a class="go" href="/collections/all">' + escHtml(t("seeAll", "see the collection")) +
          ' <span class="ar" aria-hidden="true">→</span></a></div>';
        return;
      }
      items.innerHTML = cart.items.map(function (it, i) {
        var vt = (it.variant_title && it.variant_title !== "Default Title") ? it.variant_title : "";
        return '<div class="cd-row" data-line="' + (i + 1) + '">' +
          '<a class="cdi" href="' + escHtml(it.url) + '">' + (it.image ? '<img src="' + escHtml(cartThumb(it.image)) + '" alt="' + escHtml(it.product_title) + '" width="60" height="76" loading="lazy">' : "") + "</a>" +
          '<div><div class="t">' + escHtml(it.product_title) + "</div>" +
          (vt ? '<div class="m">' + escHtml(vt) + "</div>" : "") +
          '<div class="qty"><button class="dec" type="button" aria-label="' + escHtml(t("decrease", "decrease quantity")) + '">–</button><span>' + it.quantity + '</span><button class="inc" type="button" aria-label="' + escHtml(t("increase", "increase quantity")) + '">+</button></div></div>' +
          '<div class="side"><div class="p">' + formatMoney(it.final_line_price) + '</div><button class="rm" type="button">' + escHtml(t("remove", "remove")) + '</button></div>' +
        "</div>";
      }).join("");
    }
    function cartError(msg) {
      announce(msg, true);
      if (!drawer) return;
      var err = drawer.querySelector(".cd-error");
      if (!err) {
        err = document.createElement("div");
        err.className = "cd-error"; err.setAttribute("role", "alert");
        var items = drawer.querySelector(".cd-items");
        if (items && items.parentNode) items.parentNode.insertBefore(err, items);
      }
      err.textContent = msg;
      window.setTimeout(function () { if (err.parentNode) err.parentNode.removeChild(err); }, 6000);
    }
    function refresh() {
      return fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error("cart fetch failed"); return r.json(); })
        .then(function (c) { render(c); return c; })
        .catch(function () { cartError(t("errRefresh", "couldn't refresh your bag — please reload the page.")); });
    }
    function change(line, qty) {
      return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d && (d.description || d.message) || t("errUpdate", "couldn't update your bag.")); });
          return r.json();
        })
        .then(function (c) { render(c); announce(t("updated", "bag updated — __n__", { "__n__": itemCount(c.item_count) })); return c; })
        .catch(function (err) { cartError(err && err.message ? err.message : "couldn't update your bag."); refresh(); });
    }

    // open triggers
    document.addEventListener("click", function (e) {
      var el = e.target.closest("[data-cart-toggle]");
      if (el && drawer) { e.preventDefault(); lastTrigger = el; refresh().then(open); }
    });
    if (backdrop) backdrop.addEventListener("click", close);
    var xbtn = drawer && drawer.querySelector(".cd-x");
    if (xbtn) xbtn.addEventListener("click", close);
    window.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    // qty / remove (delegated). Rows lock while a change is in flight: two quick
    // taps on + both used to read the same stale quantity and each POST qty+1,
    // so the shopper got +1 instead of +2 (and out-of-order responses could
    // render a stale cart).
    if (drawer) drawer.addEventListener("click", function (e) {
      var row = e.target.closest(".cd-row"); if (!row) return;
      if (row.classList.contains("is-busy")) return;
      var line = parseInt(row.getAttribute("data-line"), 10);
      var qty = parseInt(row.querySelector(".qty span").textContent, 10) || 1;
      var next = null;
      if (e.target.matches(".inc")) next = qty + 1;
      else if (e.target.matches(".dec")) next = Math.max(0, qty - 1);
      else if (e.target.matches(".rm")) next = 0;
      if (next === null) return;
      row.classList.add("is-busy");
      change(line, next).then(function () { row.classList.remove("is-busy"); });
    });

    // AJAX add-to-cart (UX-001: surface real errors — a 422 sold-out must never look like success)
    document.addEventListener("submit", function (e) {
      var f = e.target.closest('form[action*="/cart/add"]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;
      var formErr = f.querySelector(".form-error");
      if (formErr) formErr.remove();
      if (btn) { btn.setAttribute("data-label", btn.textContent); btn.textContent = "adding…"; btn.disabled = true; }
      function fail(msg) {
        if (btn) { btn.textContent = btn.getAttribute("data-label") || "add to bag"; btn.disabled = false; }
        var err = document.createElement("div");
        err.className = "form-error"; err.setAttribute("role", "alert");
        err.textContent = msg;
        f.appendChild(err);
        announce(msg, true);
      }
      /* The quick-add form (F—15) carries its variant id on the submit button
         itself — one button per size. `new FormData(form)` deliberately omits
         the submitter, so without this the POST goes out with no `id` at all
         and Shopify answers "Required parameter missing or invalid: items".
         FormData's submitter argument is the correct fix; the manual append
         covers browsers that ignore the second argument. */
      var submitter = e.submitter || (document.activeElement && f.contains(document.activeElement) ? document.activeElement : null);
      var fd = new FormData(f, submitter);
      if (submitter && submitter.name && !fd.has(submitter.name)) fd.append(submitter.name, submitter.value);
      fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d && (d.description || d.message) || t("errAdd", "couldn't add to bag.")); });
          return r.json();
        })
        .then(function () { return refresh(); })
        .then(function (c) {
          if (btn) { btn.textContent = btn.getAttribute("data-label") || "add to bag"; btn.disabled = false; }
          if (c) announce(t("added", "added to bag — __n__", { "__n__": itemCount(c.item_count) }));
          lastTrigger = btn || lastTrigger;
          open();
        })
        .catch(function (err) { fail(err && err.message ? err.message : t("errAddRetry", "couldn't add to bag — please try again.")); });
    });
  }

  /* ---------------- modals (size guide, etc.) ---------------- */
  function initModals() {
    var lastOpener = null;
    document.querySelectorAll(".sg-modal").forEach(function (m) {
      setInert(m, true);
      m.addEventListener("keydown", function (e) { trapFocus(m, e); });
    });
    function open(id) {
      var m = document.getElementById(id); if (!m) return;
      m.classList.add("open"); document.body.classList.add("modal-open"); setInert(m, false);
      var f = focusables(m); if (f.length) f[0].focus();
    }
    function closeAll() {
      var any = false;
      document.querySelectorAll(".sg-modal.open").forEach(function (m) { m.classList.remove("open"); setInert(m, true); any = true; });
      document.body.classList.remove("modal-open");
      if (any && lastOpener && document.contains(lastOpener)) lastOpener.focus();
    }
    document.addEventListener("click", function (e) {
      var o = e.target.closest("[data-modal-open]");
      if (o) { e.preventDefault(); lastOpener = o; open(o.getAttribute("data-modal-open")); return; }
      if (e.target.closest("[data-modal-close]")) closeAll();
    });
    window.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    var panel = document.getElementById("SearchPanel");
    if (!panel) return;
    var input = panel.querySelector(".sp-input");
    var out = panel.querySelector("[data-search-results]");
    var t, lastTrigger = null;
    setInert(panel, true);
    panel.addEventListener("keydown", function (e) { trapFocus(panel, e); });
    function open() { panel.classList.add("open"); document.body.classList.add("search-open"); setInert(panel, false); setTimeout(function () { if (input) input.focus(); }, 80); }
    function close() {
      if (!panel.classList.contains("open")) return;
      panel.classList.remove("open"); document.body.classList.remove("search-open"); setInert(panel, true);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }
    document.addEventListener("click", function (e) {
      var el = e.target.closest("[data-search-toggle]");
      if (el) { e.preventDefault(); lastTrigger = el; open(); }
    });
    panel.querySelectorAll("[data-search-close]").forEach(function (el) { el.addEventListener("click", close); });
    window.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    function render(q, res) {
      var html = "", prods = (res && res.products) || [];
      if (prods.length) {
        html += '<div class="sp-sec">garments</div><div class="sp-grid">' + prods.slice(0, 4).map(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || "");
          return '<a class="sp-card" href="' + escHtml(p.url) + '"><div class="spc-im">' + (img ? '<img src="' + escHtml(img) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : "") + '</div>' +
            '<div class="spc-info"><span class="spc-t">' + escHtml(p.title) + '</span><span class="spc-p">' + (p.price || "") + '</span></div></a>';
        }).join("") + "</div>";
      }
      var links = [];
      ((res && res.collections) || []).forEach(function (c) { links.push('<a href="' + c.url + '">' + escHtml(c.title) + "</a>"); });
      ((res && res.pages) || []).forEach(function (p) { links.push('<a href="' + p.url + '">' + escHtml(p.title) + "</a>"); });
      ((res && res.articles) || []).forEach(function (a) { links.push('<a href="' + a.url + '">' + escHtml(a.title) + "</a>"); });
      if (links.length) html += '<div class="sp-sec" style="margin-top:28px;">' + escHtml(t("otherResults", "collections · journal · pages")) + '</div><div class="sp-links">' + links.join("") + "</div>";
      if (!prods.length && !links.length) { out.innerHTML = '<div class="sp-empty">nothing found for &ldquo;' + escHtml(q) + '&rdquo;.</div>'; return; }
      html += '<a class="go sp-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">view all results <span class="ar">&rarr;</span></a>';
      out.innerHTML = html;
    }
    function fetchSuggest(q) {
      var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last";
      fetch(url, { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(q, d.resources.results); })
        .catch(function () {});
    }
    if (input) input.addEventListener("input", function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ""; return; }
      t = setTimeout(function () { fetchSuggest(q); }, 200);
    });
  }


  /* Each init isolated: the mobile nav is built entirely at runtime, so one
     throwing init must never take the site menu down with it. */
  /* ---------------- product gallery ----------------
     The sliding is CSS scroll-snap, so a swipe works whether or not this runs.
     What is added here is the part CSS cannot do: knowing which image is on
     screen, so the current dot lights, the counter counts, and an arrow knows
     when it has run out of images. The arrangement is per breakpoint, so the
     strip class goes on and comes off as the viewport crosses it. */
  function initGallery(scope) {
    (scope || document).querySelectorAll(".product-media[data-media-count]").forEach(function (root) {
      var track = root.querySelector(".pm-track");
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll(".media")) : [];
      if (!track || slides.length < 2) return;

      var marks   = Array.prototype.slice.call(root.querySelectorAll("[data-go]"));
      var arrows  = Array.prototype.slice.call(root.querySelectorAll("[data-step]"));
      var counter = root.querySelector("[data-pm-current]");
      var wide    = window.matchMedia("(min-width:901px)");
      var at = 0;

      function slidingNow() {
        return wide.matches
          ? root.classList.contains("pm-d--carousel")
          : root.classList.contains("pm-m--carousel");
      }
      function applyMode() { track.classList.toggle("pm-track--slide", slidingNow()); }
      applyMode();
      if (wide.addEventListener) wide.addEventListener("change", applyMode);

      function mark(i) {
        at = i;
        marks.forEach(function (b) {
          var on = +b.getAttribute("data-go") === i;
          b.classList.toggle("is-current", on);
          if (on) b.setAttribute("aria-current", "true");
          else b.removeAttribute("aria-current");
        });
        if (counter) counter.textContent = i + 1;
        /* an arrow that cannot go anywhere says so rather than doing nothing */
        arrows.forEach(function (a) {
          var step = +a.getAttribute("data-step");
          a.disabled = step < 0 ? i === 0 : i === slides.length - 1;
        });
      }

      function goTo(i) {
        if (i < 0 || i >= slides.length) return;
        var target = slides[i];
        if (track.classList.contains("pm-track--slide")) {
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: "smooth" });
        } else {
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        mark(i);
      }

      /* an observer rather than a scroll handler: nothing runs while idle */
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          if (!track.classList.contains("pm-track--slide")) return;
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio > 0.6) mark(slides.indexOf(e.target));
          });
        }, { root: track, threshold: [0.61] });
        slides.forEach(function (sl) { io.observe(sl); });
      }

      marks.forEach(function (b) {
        b.addEventListener("click", function () { goTo(+b.getAttribute("data-go")); });
      });
      arrows.forEach(function (a) {
        a.addEventListener("click", function () { goTo(at + (+a.getAttribute("data-step"))); });
      });
      mark(0);
    });
  }

  /* ---------------- cart page quantity stepper ----------------
     The buttons ship hidden so the page never offers a control that does
     nothing; this reveals them and wires them to the input the form already
     posts. Changing a value submits, which is what the visible "update bag"
     button did by hand. */
  function initCartQty(scope) {
    var fields = (scope || document).querySelectorAll(".cart-row .cart-qty");
    if (!fields.length) return;
    fields.forEach(function (field) {
      var input = field.querySelector("input");
      if (!input) return;
      field.querySelectorAll("[data-qty-step]").forEach(function (btn) {
        btn.hidden = false;
        btn.addEventListener("click", function () {
          var step = parseInt(btn.getAttribute("data-qty-step"), 10);
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          if (next === parseInt(input.value, 10)) return;
          input.value = next;
          input.form && input.form.requestSubmit
            ? input.form.requestSubmit(input.form.querySelector('[name="update"]'))
            : input.form && input.form.submit();
        });
      });
    });
  }

  function safe(fn) { try { fn(); } catch (err) { if (window.console && console.error) console.error("aito init failed:", err); } }
  function init() { safe(initHeader); safe(initMobileNav); safe(initNavDropdown); safe(initAccordions); safe(initProductForm); safe(initStickyAtc); safe(initCart); safe(initModals); safe(initSearch); safe(initCartQty); safe(initGallery); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---------------- theme editor ----------------
     Changing a setting re-renders the section and replaces its markup. Anything
     bound to the old elements goes with them, so without this a merchant sets
     "slider" and watches nothing happen — the requirement is that an editor
     change is reflected in the preview.

     Only these four re-run. The rest bind to document and delegate, so they
     already reach markup that did not exist when they were attached — and
     re-running them would stack a second copy of every global listener. */
  document.addEventListener("shopify:section:load", function (e) {
    var scope = e.target && e.target.querySelector ? e.target : document;
    safe(function () { initAccordions(scope); });
    safe(function () { initProductForm(scope); });
    safe(function () { initGallery(scope); });
    safe(function () { initCartQty(scope); });
  });
})();
